import { render, staticRenderFns } from "./Pengguna.vue?vue&type=template&id=0d134ba1"
import script from "./Pengguna.vue?vue&type=script&lang=js"
export * from "./Pengguna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports